
export const configureBlazeTheme = (sdk, contentType = 'moment', displayTitle = false) => {
    const themeObject = sdk.Theme('row-rectangle', contentType);
    const isDesktop =
        typeof window !== 'undefined' &&
        window.matchMedia &&
        window.matchMedia('(min-width: 1024px)').matches;

    themeObject.layoutStyle.statusLiveStyle.font = '\'Founders Grotesk\', Helvetica, Tahoma, sans-serif';
    themeObject.layoutStyle.statusLiveUnreadStyle.font = '\'Founders Grotesk\', Helvetica, Tahoma, sans-serif';
    themeObject.layoutStyle.statusReadStyle.font = '\'Founders Grotesk\', Helvetica, Tahoma, sans-serif';
    themeObject.layoutStyle.statusUnreadStyle.font = '\'Founders Grotesk\', Helvetica, Tahoma, sans-serif';
    themeObject.layoutStyle.badgeIndicatorStyle.font = '\'Founders Grotesk\', Helvetica, Tahoma, sans-serif';
    themeObject.layoutStyle.labelStyle.font = '\'Founders Grotesk\', Helvetica, Tahoma, sans-serif';

    themeObject.layoutStyle.statusUnreadStyle.backgroundColor = '#FFBA00';
    themeObject.layoutStyle.statusUnreadStyle.textColor = '#06051e';

    themeObject.layoutStyle.isScrollEnabled = true;
    themeObject.layoutStyle.rows = 3;
    themeObject.layoutStyle.columns = 0;
    themeObject.layoutStyle.horizontalItemsSpacing = 20;
    themeObject.layoutStyle.verticalItemsSpacing = 20;
    themeObject.layoutStyle.padding = '8px';
    themeObject.layoutStyle.labelStyle.fontSize = isDesktop ? '16px' : '14px';
    themeObject.layoutStyle.labelStyle.fontWeight = 'normal';

    if (themeObject.layoutStyle.labelStyle) {
        themeObject.layoutStyle.labelStyle.isVisible = displayTitle;

        if (!displayTitle) {
            themeObject.layoutStyle.labelStyle.gap = 0;
            themeObject.layoutStyle.labelStyle.height = 0;
            themeObject.layoutStyle.labelStyle.fontSize = '0px';
            themeObject.layoutStyle.labelStyle.color = 'transparent';
            themeObject.layoutStyle.labelStyle.backgroundColor = 'transparent';
        }
    }

    return themeObject;
};

export const getBlazeDataSource = (sdk, labelsString) => {
    const labelArray = labelsString ? labelsString.split(',').map((l) => l.trim()).filter(Boolean) : [];

    if (labelArray.length === 0) {
        return sdk.DataSourceBuilder().all();
    }

    let labelsSource;

    if (labelArray.length > 1) {
        labelsSource = sdk.LabelBuilder().mustInclude(...labelArray);
    } else {
        labelsSource = sdk.LabelBuilder().singleLabel(labelArray[0]);
    }

    return sdk.DataSourceBuilder().labels({
        labels: labelsSource,
        maxItems: 20,
    });
};
